<template>
  <div class="inner">
    <EmptyDisplay class="mt-4" :src="surveyImage" alt="Surveys" title="Carrier Survey Results" text="Please choose from one of the carrier surveys below.">
      <div class="mt-8 flex gap-4">
        <AppButton primary @click="goTo('/carriers/survey/do')">Directors &amp; Officers</AppButton>
        <AppButton primary @click="goTo('/carriers/survey/tl')">Reps &amp; Warranties</AppButton>
        <AppButton primary @click="goTo('/carriers/survey/cyber')">Cyber</AppButton>
      </div>
    </EmptyDisplay>
  </div>
</template>

<script lang="ts">
import EmptyDisplay from '@/components/EmptyDisplay.vue';
import AppButton from '@/components/v2/AppButton.vue';

export default {
  name: 'CarrierSurveyList',
  components: { EmptyDisplay, AppButton },
};
</script>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import surveyImage from '@/assets/images/survey.svg';

const router = useRouter();

function goTo(path: string) {
  router.push(path);
}
</script>